<script>
  import { mdbContainer, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbInput, mdbBtn } from 'mdbvue'
  export default {
    data: () => ({
      form: {
        email: '',
        password: ''
      },
      errors: null,
      show: true,
      isValidationActive: false
    }),
    computed: {
      isValid () {
        return this.errors === null
      }
    },
    methods: {
      submit () {
        this.isValidationActive = false
        this.errors = null
        this.$store.dispatch('user/SIGN_IN', {
          email: this.form.email,
          password: this.form.password
        })
          .then(data => this.handleSignInSuccess(data))
          .catch(data => this.handleSignInError(data))
      },
      handleSignInSuccess () {
        this.$snotify.success('', 'Zalogowano poprawnie')
      },
      handleSignInError (data) {
        if (data.error == 'user_not_active') {
          this.$snotify.error('', 'Konto nie zostało aktywowane.')
        } else {
          this.$snotify.error('', 'Błędne dane logowania')
        }
        this.errors = data.error
        this.$nextTick(() => { this.isValidationActive = true })
      }
    },
    components: {
      mdbContainer,
      mdbRow,
      mdbCol,
      mdbCard,
      mdbCardBody,
      mdbInput,
      mdbBtn
    }
  }
</script>

<template>
  <mdbContainer class="p-login">
    <mdb-row class="justify-content-center align-items-center">
      <mdb-col lg="5" class="mb-4">
        <mdb-card>
          <mdb-card-body>
            <!-- Material form login -->
            <form @submit.prevent="submit" class="needs-validation" novalidate>
              <p class="h4 text-center mb-4">Logowanie</p>
              <div class="grey-text">
                <mdb-input
                  label="Adres e-mail"
                  icon="envelope"
                  type="email"
                  v-model="form.email"
                  :customValidation="isValidationActive"
                  :isValid="isValid"
                />
                <div class="invalid-feedback">
                  Please provide a valid city.
                </div>
                <mdb-input
                  label="Hasło"
                  icon="lock"
                  type="password"
                  v-model="form.password"
                  :customValidation="isValidationActive"
                  :isValid="isValid"
                />
              </div>
              <div class="text-center">
                <mdb-btn color="primary">Zaloguj</mdb-btn>
              </div>
            </form>
            <!-- Material form login -->
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdbContainer>
</template>

<style lang="scss">
  .p-login {
    &,
    & > div {
      flex: 1 0 auto;
      height: 100%;
    }
    display: flex;
    flex-direction: column;
  }
</style>
